import { useState } from "react";
import { Seo, breadcrumbLd } from "../lib/seo";
import { MaskedLine, FadeIn, Reveal } from "../components/Reveal";
import { Eyebrow } from "../components/atoms";
import { FaqAccordion } from "../components/FaqAccordion";
import { FAQS, FAQ_CATEGORIES } from "../data/content";

export default function Faqs() {
  const [cat, setCat] = useState("which");
  const list = FAQS.filter((f) => f.cat === cat);

  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo
        title="Property advisory questions, answered | 80 Metrics"
        description="Clear answers to the questions clients ask before they engage us — SuburbIQ, Property & Portfolio Assessment, Buyer Advocacy and Vendor Advocacy."
        jsonLd={[faqLd, breadcrumbLd([{ name: "Home", path: "/" }, { name: "FAQs", path: "/faqs" }])]}
      />
      <section className="bg-charcoal text-ivory" data-testid="faqs-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-28 pb-14 lg:pb-20">
          <FadeIn delay={0.1}>
            <Eyebrow dark>FAQs</Eyebrow>
          </FadeIn>
          <h1 className="mt-8 font-serif font-medium text-4xl sm:text-5xl lg:text-7xl leading-[1.04] tracking-tight max-w-4xl">
            <MaskedLine delay={0.25}>Property advisory questions,</MaskedLine>
            <MaskedLine delay={0.37}>
              <span className="italic text-gold">answered.</span>
            </MaskedLine>
          </h1>
        </div>
      </section>

      <section className="bg-white" data-testid="faqs-body">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <h2 className="font-serif text-2xl lg:text-3xl font-medium text-charcoal">What are you trying to work out?</h2>
              <div className="mt-8 flex lg:flex-col flex-wrap gap-3" data-testid="faq-filters">
                {FAQ_CATEGORIES.map((c) => (
                  <button
                    key={c.key}
                    onClick={() => setCat(c.key)}
                    data-testid={`faq-filter-${c.key}`}
                    className={`text-left px-5 py-3.5 text-[11px] font-semibold tracking-[0.18em] uppercase border transition-[background-color,color,border-color] duration-300 ${
                      cat === c.key
                        ? "bg-charcoal text-gold border-charcoal"
                        : "border-charcoal/25 text-charcoal/60 hover:border-charcoal hover:text-charcoal"
                    }`}
                  >
                    {c.label}
                  </button>
                ))}
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.08}>
              <FaqAccordion key={cat} items={list} testidPrefix={`faq-${cat}`} />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
